import { SxProps } from '@mui/material';
import {
  black1,
  greyText,
  yellow,
  yellowActive,
  yellowDefault,
  yellowHover,
} from 'app/components/ThemeProvider/colors';

export const container: SxProps = {
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
};

export const line: SxProps = {
  width: '100%',
  height: '8px',
  background: yellow,
};

export const header: SxProps = {
  p: '29px 728px',
};

export const mainText: SxProps = {
  fontFamily: 'Yelo',
  fontSize: '28px',
  mt: '30px',
  fontWeight: '600',
};

export const secondaryText: SxProps = {
  fontFamily: 'Yelo',
  fontSize: '18px',
  fontWeight: '600',
  mt: '12px',
  color: greyText,
  textAlign: 'center',
  maxWidth: '385px',
};

export const btn: SxProps = {
  padding: '8px 16px',
  fontStyle: 'normal',
  fontWeight: 600,
  fontSize: '16px',
  lineHeight: '22px',
  textTransform: 'unset',
  borderRadius: '8px',
  fontFamily: 'Yelo',
  gap: '8px',
  mt: '24px',
  size: 'large',

  color: black1,
  backgroundColor: yellowDefault,
  '&:hover': {
    backgroundColor: yellowHover,
  },
  '&:active': {
    backgroundColor: yellowActive,
  },

  boxShadow: 'none',

  '& .MuiSvgIcon-root': {
    height: '22px',
    width: '22px',
  },
};
